/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import { Box, Typography, Grid2, Avatar } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import AKS from "./assets/1.webp";

const settings = {
  width: 140,
  height: 140,
  value: 86,
};

function PlayerReport() {
  // Sample data for player report
  const playerData = {
    name: "سید علی فیاض",
    totalDistance: 3.28, // Total distance (km)
    walkDistance: 1.24, // Walk distance (km)
    runDistance: 1.568, // Run distance (km)
    sprintDistance: 0.467, // Sprint distance (km)
  };

  // Sample data for bar chart - Distance Breakdown per time interval
  const chartData = [
    { interval: "0-5 دقیقه", walk: 400, run: 279, sprint: 152 },
    { interval: "5-10 دقیقه", walk: 152, run: 116, sprint: 69 },
    { interval: "10-15 دقیقه", walk: 82, run: 43, sprint: 33 },
    { interval: "15-20 دقیقه", walk: 33, run: 48, sprint: 26 },
    { interval: "20-25 دقیقه", walk: 69, run: 45, sprint: 43 },
    { interval: "25-30 دقیقه", walk: 153, run: 165, sprint: 62 },
    { interval: "30-35 دقیقه", walk: 295, run: 165, sprint: 88 },
    { interval: "35-40 دقیقه", walk: 89, run: 66, sprint: 62 },
    { interval: "40-45 دقیقه", walk: 165, run: 99, sprint: 59 },
    { interval: "45-50 دقیقه", walk: 92, run: 132, sprint: 98 },
    { interval: "50-55 دقیقه", walk: 160, run: 82, sprint: 110 },
    { interval: "55-60 دقیقه", walk: 152, run: 159, sprint: 90 },
    { interval: "60-65 دقیقه", walk: 210, run: 167, sprint: 100 },
  ];

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        padding: 2,
        direction: "ltr",
      }}
    >
      {/* Player Report Title */}
      <Typography variant="h4" sx={{ marginBottom: 3, textAlign: "right" }}>
        گزارش بازیکن
      </Typography>
      <Grid2 container spacing={2}>
        {/* Player Data Section */}
        <Grid2
          size={12}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: 1,
            direction: "rtl",
          }}
        >
          <Grid2
            container
            spacing={2}
            sx={{
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography
                variant="h6"
                sx={{ textAlign: "right", marginBottom: "5px" }}
              >
                نام بازیکن: {playerData.name}
              </Typography>
              <Typography variant="body1" sx={{ textAlign: "right" }} mr={1}>
                مسافت کل: {playerData.totalDistance} کیلومتر
              </Typography>
              <Typography variant="body1" sx={{ textAlign: "right" }} mr={1}>
                مسافت پیاده‌روی: {playerData.walkDistance} کیلومتر
              </Typography>
              <Typography variant="body1" sx={{ textAlign: "right" }} mr={1}>
                مسافت دویدن: {playerData.runDistance} کیلومتر
              </Typography>
              <Typography variant="body1" sx={{ textAlign: "right" }} mr={1}>
                مسافت دویدن سریع: {playerData.sprintDistance} کیلومتر
              </Typography>
            </Grid2>

            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Gauge
                {...settings}
                cornerRadius="50%"
                sx={(theme) => ({
                  [`& .${gaugeClasses.valueText}`]: {
                    fontSize: 40,
                  },
                  [`& .${gaugeClasses.valueArc}`]: {
                    fill: "#52b202",
                  },
                  [`& .${gaugeClasses.referenceArc}`]: {
                    fill: theme.palette.text.disabled,
                  },
                })}
              />
            </Grid2>

            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar src={AKS} alt="pic" sx={{ width: 128, height: 128 }} />
            </Grid2>
          </Grid2>
        </Grid2>

        <Grid2
          size={12}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: 2,
          }}
        >
          {/* Distance Breakdown Chart */}
          <Typography variant="h6" sx={{ textAlign: "right", marginBottom: 2 }}>
            : تفکیک مسافت بر اساس زمان در بازی تمرین اردو
          </Typography>
          <BarChart
            borderRadius={5}
            xAxis={[
              {
                scaleType: "band",
                data: chartData.map((item) => item.interval),
              },
            ]}
            series={[
              {
                data: chartData.map((item) => item.walk),
                valueFormatter: (value) => `${value} m`,
                label: "پیاده‌روی",
                color: "#66b3ff",
              },
              {
                data: chartData.map((item) => item.run),
                valueFormatter: (value) => `${value} m`,
                label: "دویدن",
                color: "#4d94ff",
              },
              {
                data: chartData.map((item) => item.sprint),
                valueFormatter: (value) => `${value} m`,
                label: "دویدن سریع",
                color: "#1a75ff",
              },
            ]}
            height={400}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default PlayerReport;
